/**
 * Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import { UploaderStateModel, UploaderType } from './upload.model';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { SelectUploader } from './upload.actions';
import { DashGisUtil } from '../../../../../shared/dash-gis-util';
import { Injectable } from '@angular/core';

@State<UploaderStateModel>({
    name: 'uploader',
    defaults: {
        uploader: UploaderType.FILE,
    },
})
@Injectable()
export class UploaderState {

    @Action(SelectUploader)
    selectUploader({getState, setState}: StateContext<UploaderStateModel>, action: SelectUploader) {
        const state = DashGisUtil.clone(getState());
        if (state.uploader !== action.payload.uploader) {
            state.uploader = action.payload.uploader;
            setState(state);
        }
    }

    @Selector()
    static uploader(state: UploaderStateModel): UploaderType { return state.uploader; }
}
